import "./style.scss";

import { Col, Row } from "@amzn/stencil-react-components/layout";
import { PropsWithChildren, ReactNode } from "react";

import {
  progressRailColumnClassName,
  progressTrackerLayoutClassName,
  stepContentColumnClassName,
} from "@/components/constants";

interface OnboardingPageLayoutProps extends PropsWithChildren<unknown> {
  /**
   * The progress rail rendered in the left column. The rail itself (stepper and
   * progress summary) is added by NHE-5713 follow-up work; until then the column
   * renders empty so the layout can be validated on its own.
   */
  rail?: ReactNode;
}

/**
 * Two column layout for the Day1 onboarding page.
 *
 * The left column holds the vertical progress rail and the right column holds the
 * page heading and the active step's content. Below the small breakpoint the
 * columns stack so the step content keeps a usable width.
 */
export default function OnboardingPageLayout({
  rail,
  children,
}: OnboardingPageLayoutProps): JSX.Element {
  return (
    <Row
      alignItems="flex-start"
      className={progressTrackerLayoutClassName}
      dataTestId="onboardingPageLayout"
    >
      <Col
        className={progressRailColumnClassName}
        dataTestId="progressRailColumn"
      >
        {rail}
      </Col>
      <Col
        className={stepContentColumnClassName}
        dataTestId="stepContentColumn"
      >
        {children}
      </Col>
    </Row>
  );
}
